import { sqHomeScreenStore } from '@/core/core.stores';
import { getCancellationGroupForTable, loadTable, setSearchParams } from '@/homescreen/homescreen.actions';
import { HOME_SCREEN_TABLE_TYPE } from '@/homescreen/homescreen.constants';
import type { HomeScreenSearchParams } from '@/homescreen/homescreen.store';

export function loadSearchTable({
  searchParams,
  isCurrentFolderNested = false,
  advancedSearchSelectedFolder = '',
  locationChangedInAdvanced = false,
  breadcrumbClicked = false,
}: {
  searchParams?: HomeScreenSearchParams;
  isCurrentFolderNested?: boolean;
  advancedSearchSelectedFolder?: string;
  locationChangedInAdvanced?: boolean;
  breadcrumbClicked?: boolean;
}) {
  const table = HOME_SCREEN_TABLE_TYPE.SEARCH;
  const searchSort = sqHomeScreenStore.getSortForTable(table);
  let sortOrder: string | undefined;
  if (searchSort?.sortProperty) {
    sortOrder = `${searchSort.sortProperty} ${(searchSort.sortAsc ?? true) ? 'asc' : 'desc'}`;
  }

  const nextSearchParams: HomeScreenSearchParams = searchParams
    ? { ...searchParams, sortOrder }
    : { ...sqHomeScreenStore.searchParams, sortOrder };

  if (!searchParams) {
    setSearchParams(nextSearchParams);
  }
  return loadTable({
    searchParams: nextSearchParams,
    table,
    isCurrentFolderNested,
    advancedSearchSelectedFolder,
    locationChangedInAdvanced,
    breadcrumbClicked,
    cancellationGroup: getCancellationGroupForTable('search'),
  });
}
